import { ChangeDetectionStrategy, Component, computed, inject, input } from "@angular/core";
import { UtilityService } from "@eforall/common";
import { DialogService, GridContentWidget } from "@eforall/dashboard";
import { ReadonlyAccessWidget } from "../../../readonly-access/readonly-access.widget";
import { AccTeamDialogDataService } from "../acc-team-dialog-data.service";
import { getSetup } from "./grid/get-setup";

@Component({
	selector: 'acc-team-mentors-part',
	standalone: true,
	imports: [
		GridContentWidget,
		ReadonlyAccessWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './mentors.part.html'
})
export class AccTeamMentorsPart {

	private readonly util = inject(UtilityService);
	private readonly dialogService = inject(DialogService);
	public readonly dialogDataService = inject(AccTeamDialogDataService);

	public dialogBodyHeight = input.required<number>();

	// subtracting 60 to account for padding and tabstrip, also for readonly access bar if applicable 
	public customHeight = computed(() => this.dialogBodyHeight() - 60 - (this.dialogDataService.canEdit() ? 0 : 40));

	public setup = getSetup(this.util, this.dialogService, this.dialogDataService);

}